
import { useRef, useEffect, useState } from 'react';

const TECHS = [
  { name: 'React', icon: 'ri-reactjs-line', color: '#00d4ff' },
  { name: 'Next.js', icon: 'ri-code-box-line', color: '#ffffff' },
  { name: 'TypeScript', icon: 'ri-code-s-slash-line', color: '#00d4ff' },
  { name: 'Tailwind', icon: 'ri-layout-4-line', color: '#00ff88' },
  { name: 'Node.js', icon: 'ri-server-line', color: '#00ff88' },
  { name: 'WordPress', icon: 'ri-wordpress-line', color: '#ffffff' },
  { name: 'Figma', icon: 'ri-pen-nib-line', color: '#ff6b9d' },
  { name: 'Google Ads', icon: 'ri-google-line', color: '#ff6b9d' },
  { name: 'Analytics', icon: 'ri-bar-chart-2-line', color: '#00d4ff' },
  { name: 'OpenAI', icon: 'ri-robot-2-line', color: '#00ff88' },
  { name: 'AWS', icon: 'ri-cloud-line', color: '#ffffff' },
  { name: 'Vercel', icon: 'ri-triangle-line', color: '#ffffff' },
];

export default function TechSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 bg-[#060606] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#00d4ff] text-xs uppercase tracking-[3px] font-semibold mb-4">Technologie</p>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-3">
            Pracujemy z najlepszymi narzędziami
          </h2>
          <p className="text-white/40 text-sm max-w-lg mx-auto">
            Dobieramy technologie do projektu — nie odwrotnie. Zawsze najnowsze, zawsze sprawdzone.
          </p>
        </div>

        <div className="grid grid-cols-4 md:grid-cols-6 lg:grid-cols-12 gap-4">
          {TECHS.map((tech, i) => (
            <div
              key={tech.name}
              className="group flex flex-col items-center gap-2 p-4 rounded-2xl border border-white/8 bg-white/[0.02] hover:border-white/20 hover:bg-white/[0.05] transition-all duration-300 cursor-default"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(20px)',
                transition: `opacity 0.5s ease ${i * 0.05}s, transform 0.5s ease ${i * 0.05}s, border-color 0.3s, background 0.3s`,
              }}
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${tech.icon} text-2xl`} style={{ color: tech.color }} />
              </div>
              <span className="text-white/40 text-[10px] font-medium text-center group-hover:text-white/70 transition-colors whitespace-nowrap">{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
